export const inquiryActionFormName = 'inquiryActionForm';
export const newInquiryFormName = 'newInquiryForm';

export const TAB_NAMES = {
    ABOUT: 'about',
    RELATIONS: 'relations',
    BOOKINGS: 'bookings',
};

export const LIMITED_ICON_SIZE = 12;
